var _style, _defs, _path, _defs2, _path2, _defs3, _path3, _defs4, _path4, _defs5, _path5, _defs6, _path6, _defs7, _path7, _defs8, _path8, _defs9, _polygon, _defs10, _polygon2, _defs11, _polygon3, _defs12, _polygon4, _defs13, _polygon5, _defs14, _polygon6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStopoverLogoAllWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 249.3 124.9",
    style: {
      enableBackground: "new 0 0 249.3 124.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_2_);fill:#FFFFFF;}\r\n\t.st1{clip-path:url(#SVGID_4_);fill:#FFFFFF;}\r\n\t.st2{clip-path:url(#SVGID_6_);fill:#FFFFFF;}\r\n\t.st3{clip-path:url(#SVGID_8_);fill:#FFFFFF;}\r\n\t.st4{clip-path:url(#SVGID_10_);fill:#FFFFFF;}\r\n\t.st5{clip-path:url(#SVGID_12_);fill:#FFFFFF;}\r\n\t.st6{clip-path:url(#SVGID_14_);fill:#FFFFFF;}\r\n\t.st7{clip-path:url(#SVGID_16_);fill:#FFFFFF;}\r\n\t.st8{clip-path:url(#SVGID_18_);fill:#FFFFFF;}\r\n\t.st9{clip-path:url(#SVGID_20_);fill:url(#SVGID_21_);}\r\n\t.st10{clip-path:url(#SVGID_23_);fill:url(#SVGID_24_);}\r\n\t.st11{clip-path:url(#SVGID_26_);fill:#FFFFFF;}\r\n\t.st12{clip-path:url(#SVGID_28_);fill:url(#SVGID_29_);}\r\n\t.st13{clip-path:url(#SVGID_31_);fill:url(#SVGID_32_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -189,
    y: -167,
    width: 595.3,
    height: 841.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.7,62.2c0.6,0,0.9-0.3,0.9-0.9v-3.5c0-0.3-0.2-0.5-0.5-0.7s-1.7-0.4-4.1-0.6c-2.4-0.2-4.6-0.4-6.4-0.4 c-8.8,0-13.2,3.3-13.2,10c0,2.2,0.5,4,1.6,5.5c1,1.5,2.6,2.9,4.9,4.1l8.2,4.8c0.9,0.6,1.8,1.2,2.5,1.9c0.7,0.7,1.1,1.6,1.1,2.7 c0,1.8-0.5,3-1.5,3.8c-1,0.7-2.6,1.1-4.7,1.1c-1.1,0-2.7-0.1-4.8-0.2s-3.7-0.2-4.8-0.4h-0.1c-0.3,0-0.5,0.1-0.7,0.3 c-0.2,0.2-0.3,0.4-0.3,0.7v3.7c0,0.3,0.1,0.5,0.3,0.7s1.3,0.5,3.3,0.8s4.3,0.4,6.7,0.4c3,0,5.5-0.4,7.6-1.4 c2.1-0.9,3.6-2.2,4.7-3.9c1.1-1.7,1.6-3.6,1.6-5.8c0-2.5-0.6-4.5-1.8-6.2s-3.1-3.2-5.6-4.6l-7.2-4c-1-0.5-1.8-1.1-2.5-1.8 C19,67.9,18.6,67,18.6,66c0-2.5,1.8-3.8,5.5-3.8H34.7L34.7,62.2z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: -189,
    y: -167,
    width: 595.3,
    height: 841.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.4,91c0-0.6-0.4-0.9-1.1-0.9h-2.8c-1.1,0-1.7-0.2-1.9-0.6s-0.2-1.1-0.2-2.3V70.7h5c0.3,0,0.6-0.1,0.8-0.3 c0.2-0.2,0.3-0.4,0.3-0.7v-2.9c0-0.3-0.1-0.5-0.3-0.7s-0.5-0.3-0.8-0.3h-5v-5.3c0-0.5-0.3-0.8-0.9-0.8h-0.2l-4,0.7 c-1.1,0.2-1.7,0.3-1.9,0.5s-0.3,0.4-0.3,0.7v4.2h-5c-0.3,0-0.5,0.1-0.8,0.3c-0.2,0.2-0.3,0.4-0.3,0.7V69c0,0.3,0.1,0.5,0.3,0.6 c0.2,0.2,0.4,0.3,0.5,0.3s1.9,0.3,5.3,0.7v16.9c0,3.1,0.5,5.3,1.6,6.6c1,1.3,3.4,2,7,2c0.6,0,1.5-0.1,2.6-0.2 c1.1-0.2,1.7-0.3,1.9-0.5s0.3-0.4,0.3-0.7L56.4,91L56.4,91z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: -189,
    y: -167,
    width: 595.3,
    height: 841.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M75,88.3c-1,1.2-2.3,1.8-4,1.8c-1.8,0-3.1-0.6-4-1.9c-1-1.3-1.4-3-1.4-5.1v-4.2c0-2.2,0.5-3.9,1.4-5.2 c0.9-1.2,2.3-1.9,4-1.9s3.1,0.6,4,1.9c1,1.2,1.4,3,1.4,5.2v4.2C76.4,85.3,75.9,87,75,88.3 M83.7,78.9c0-4-1.1-7.1-3.4-9.5 C78,67,74.9,65.9,71,65.9c-4,0-7.1,1.2-9.4,3.5c-2.3,2.4-3.4,5.5-3.4,9.5v4.2c0,4,1.1,7.2,3.4,9.5c2.3,2.4,5.4,3.6,9.4,3.6 c3.9,0,7-1.2,9.3-3.6c2.3-2.3,3.4-5.5,3.4-9.5C83.7,83.1,83.7,78.9,83.7,78.9z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    x: -189,
    y: -167,
    width: 595.3,
    height: 841.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M103.7,88.4c-0.8,1.1-2.1,1.7-3.9,1.7c-1.4,0-3-0.1-4.6-0.3V72.2c1.2-0.2,2.7-0.3,4.6-0.3 c1.7,0,3,0.6,3.9,1.7c0.8,1.1,1.3,3,1.3,5.5v3.8C104.9,85.5,104.5,87.3,103.7,88.4 M112.2,79c0-4.2-1.1-7.5-3.2-9.8 s-5.2-3.4-9.2-3.4c-2.3,0-4.7,0.2-7.1,0.7c-2.4,0.4-3.8,0.8-4.2,1c-0.4,0.3-0.5,0.6-0.5,1.1V106c0,0.3,0.1,0.5,0.3,0.8 c0.2,0.2,0.5,0.3,0.8,0.3h5.1c0.3,0,0.5-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8V95.9c1.8,0.2,3.4,0.3,4.9,0.3c4,0,7-1.1,9-3.4 s3.1-5.5,3.1-9.7V79H112.2z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_9_",
    x: -189,
    y: -167,
    width: 595.3,
    height: 841.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M147.9,87.6c-1.3,1.7-3.3,2.5-6,2.5s-4.7-0.8-6-2.5s-1.9-4.3-1.9-7.8v-7.3c0-3.5,0.6-6.1,1.9-7.8 c1.3-1.7,3.3-2.5,6-2.5s4.7,0.9,6,2.5c1.3,1.7,1.9,4.3,1.9,7.8v7.3C149.8,83.3,149.1,85.9,147.9,87.6 M157,72.6 c0-5.3-1.3-9.4-4-12.2c-2.6-2.8-6.4-4.2-11.2-4.2c-4.6,0-8.3,1.4-11,4.1c-2.7,2.7-4.1,6.8-4.1,12.4v7.1c0,5.4,1.3,9.4,4,12.2 c2.6,2.8,6.4,4.2,11.2,4.2s8.6-1.4,11.2-4.2c2.6-2.8,4-6.9,4-12.2v-7.2H157z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_11_",
    x: -189,
    y: -167,
    width: 595.3,
    height: 841.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M180.8,65.9c-0.6,0-1,0.4-1.1,1l-5.1,21.9c-0.2,0.9-0.6,1.3-1,1.3c-0.5,0-0.8-0.4-1-1.3l-5.1-21.9 c-0.2-0.7-0.5-1-1.1-1H161c-0.6,0-0.9,0.3-0.9,0.9c0,0.2,0,0.3,0,0.4l6.7,24.1c0.9,3.3,3.1,5,6.6,5s5.8-1.6,6.7-5l6.7-24.1 c0-0.1,0-0.2,0-0.4c0-0.6-0.3-0.9-0.8-0.9H180.8z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_13_",
    x: -189,
    y: -167,
    width: 595.3,
    height: 841.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M195.9,78v-0.2c0-1.8,0.5-3.2,1.5-4.3c1-1,2.3-1.6,4-1.6c1.6,0,2.9,0.5,3.9,1.6s1.5,2.5,1.5,4.3V78H195.9z  M214,78.7c0-3.9-1.1-7-3.4-9.4c-2.3-2.3-5.3-3.5-9.3-3.5s-7.1,1.2-9.4,3.5c-2.3,2.4-3.4,5.6-3.4,9.8V83c0,4.3,1.2,7.5,3.7,9.8 c2.4,2.3,5.5,3.4,9.2,3.4c3.1,0,5.6-0.1,7.5-0.4s3-0.5,3.4-0.6c0.3-0.1,0.5-0.6,0.5-1.2v-3.5c0-0.5-0.3-0.8-0.9-0.8h-0.2l-4.6,0.4 c-1.7,0.1-3.4,0.2-5,0.2c-2.3,0-3.9-0.7-4.8-2.1c-1-1.4-1.4-3.1-1.4-5V83H213c0.7,0,1.1-0.4,1.1-1.3v-3H214z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_15_",
    x: -189,
    y: -167,
    width: 595.3,
    height: 841.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M234,66.9c0-0.3-0.1-0.5-0.3-0.8c-0.2-0.2-0.5-0.3-0.7-0.3c-2.8,0-5.3,0.7-7.4,2.2v-1.1 c0-0.3-0.1-0.5-0.4-0.7c-0.2-0.2-0.5-0.3-0.8-0.3h-5c-0.3,0-0.6,0.1-0.8,0.3c-0.2,0.2-0.3,0.5-0.3,0.8v28c0,0.3,0.1,0.6,0.4,0.8 c0.2,0.2,0.5,0.3,0.7,0.3h5.1c0.3,0,0.5-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8V73.1c2.4-0.8,4.9-1.2,7.4-1.2c0.3,0,0.6-0.1,0.8-0.3 c0.2-0.2,0.3-0.5,0.3-0.8v-3.9H234z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_17_",
    d: "M10.4,20.6c0,0.2,0,3.9,0.1,4.1c24.2,0.2,58,4,59.3,4.2c0.4,0.1,35.6,26.4,49,35.5v-5.7 c-24.4-29.5-32-42.9-64.2-42.9C43.4,15.8,29.3,17.4,10.4,20.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "-8.1,55.8 29.6,-25.6 137.4,24.4 99.7,105.7  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_19_",
    d: "M118.4,64.1L118.4,64.1C118.3,64.1,118.4,64.1,118.4,64.1 M118.3,64.1C118.3,64.1,118.3,64,118.3,64.1 L118.3,64.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: -3582.45,
    y1: 3592.6797,
    x2: -3581.45,
    y2: 3592.6797,
    gradientTransform: "matrix(3.600000e-02 -6.100000e-02 6.100000e-02 3.600000e-02 28.1443 -283.766)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#31BFF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0099C3"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "118.2,64.1 118.3,64 118.4,64.1 118.4,64.2  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_22_",
    d: "M118.4,60.5l-0.1-0.2C118.3,60.4,118.3,60.4,118.4,60.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_23_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_22_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: -716.621,
    y1: 265.2444,
    x2: -715.621,
    y2: 265.2444,
    gradientTransform: "matrix(0.285 -0.486 0.486 0.285 193.5825 -363.3593)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#31BFF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0099C3"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "118.2,60.4 118.3,60.2 118.5,60.3 118.4,60.5  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_25_",
    d: "M176.5,34.4L176.5,34.4L176.5,34.4L176.5,34.4 M118.9,58.7v5.7c1.5-2.5,18.2-29.6,19.4-30.3 c1-0.6,36.2,2.8,38.1,3.1c0.2,0,0.1-0.7,0.1-1.4c-0.1-0.7-0.1-1.4,0-1.4c-13.6-6-24-8.8-31.8-8.8 C128.4,25.6,122.4,37.5,118.9,58.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_26_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_25_",
    style: {
      overflow: "visible"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "134.8,90.2 101.5,36.3 160.6,-0.2 193.9,53.6  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_27_",
    d: "M119.6,57.7l0.1-0.8C119.7,57.2,119.6,57.4,119.6,57.7 M119.7,56.9L119.7,56.9L119.7,56.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_28_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_27_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: -454.7096,
    y1: -230.2179,
    x2: -453.7096,
    y2: -230.2179,
    gradientTransform: "matrix(-1.005 -2.1 2.1 -1.005 146.33 -1128.5974)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#31BFF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0099C3"
    }
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "119.6,57.8 119.3,57 119.7,56.7 120.1,57.5  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_30_",
    d: "M119.6,64.4c0,0,0.1-0.1,0.1-0.2L119.6,64.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_31_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_30_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: -1183.3712,
    y1: -317.6024,
    x2: -1182.3712,
    y2: -317.6024,
    gradientTransform: "matrix(-0.173 -0.362 0.362 -0.173 30.0292 -419.012)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#31BFF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0099C3"
    }
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "119.7,64.4 119.6,64.2 119.8,64.1 119.9,64.3  "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopoverLogoAllWhite);
export default __webpack_public_path__ + "static/media/stopover-logo-all-white.b97d92fe8a25e30ee35d07c5e67a68ec.svg";
export { ForwardRef as ReactComponent };